import angular from 'angular';

export default class LineController {
     static $inject = ['$scope','$element','$compile'];
    constructor($scope, $element, $compile) {
        'ngInject';
        this.$scope = $scope;
        this.$element = $element;
        this.$compile = $compile;
        this.options = {
            responsive: false,
            maintainAspectRatio: false,
            elements: {
                line: {
                    tension: 0.4,
                    fill: false,
                    borderWidth: 2
                }
            },
            pointDot: true,
            pointDotRadius: 5,
            pointDotStrokeWidth: 1,
            pointHitDetectionRadius: 20,
            scales: {
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: this.ylabel
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: (this.xlabel == 'Time') ? 'Timeline' : this.xlabel
                    },
                    gridLines: {
                        display: false
                    }
                }]
            },
            legend: {
                display: false
            },
            tooltips: {
                intersect: false,
                position: 'average',
                mode: 'point'
            },
            title: {
                display: true,
                text: this.title,
                lineHeight: '1'
            },
            legendCallback: chart => {
                const lis = chart.data.datasets.map((d, index) => {
                    const isItemHidden = this.excludedItems.indexOf(d.label) !== -1;
                    if (isItemHidden) {
                        const meta = chart.getDatasetMeta(index);
                        meta.hidden = true;
                    }

                    return `<li ${isItemHidden ? 'class="removed"' : ''} data-item="${d.label}" data-ng-click="$ctrl.onLegendItemClick($event, ${index})" title="${d.label}"><span style="border-color: ${d.borderColor}; background-color: ${d.borderColor}"></span> ${d.label}</li>`;
                });
                chart.update();

                return `<ul>${lis.join('')}</ul>`;
            }
        };
    }

    $onInit() {
        this.calculateStyles(this.height);
        this.unwatchHeight = this.$scope.$watch(() => this.height, (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.calculateStyles(newValue);
            }
        });
        this.unwatchTitle = this.$scope.$watch(() => this.title, (newValue, oldValue) => {
            this.options.title.text = newValue;
        });
        const offCreateChart = this.$scope.$on('chart-create', (e, chart) => {
            this.chart = chart;
            const legend = this.$compile(chart.generateLegend())(this.$scope);
            this.$element.find('.legend-container').html(legend);
        });
    }

    $onDestroy() {
        this.unwatchHeight();
        this.unwatchTitle();
    }

    calculateStyles(height) {
        // this.wrapperStyle = { 'max-height': `${height}px` };
        this.boxStyle = { height: `${height - 50}px` };
        this.legendStyle = { height: `${height - 70}px` };
    }

    onLegendItemClick(e, index) {
        const target = e.target.nodeName === 'LI' ? e.target : e.target.parentNode;
        const meta = this.chart.getDatasetMeta(index);
        meta.hidden = !meta.hidden;
        if (meta.hidden) {
            target.classList.add('removed');
        } else {
            target.classList.remove('removed');
        }
        this.onLegendItemToggle(target.dataset.item);
        this.chart.update();
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/line/line.controller.js